import firstCarouselImage from 'assets/images/contaMei/firstCarouselImage.png'
import secondCarouselImage from 'assets/images/contaMei/secondCarouselImage.png'
import thirdCarouselImage from 'assets/images/contaMei/thirdCarouselImage.png'
import fourthCarouselImage from 'assets/images/contaMei/fourthCarouselImage.png'

export const slidersAccountInfo = [
  {
    img: firstCarouselImage,
    title: 'Aumente seus lucros e diminua seus gastos',
    contents: 'Com uma conta gratuita, 100% digital e transações sem taxas.',
  },
  {
    img: secondCarouselImage,
    title: 'Aproveite cartão sem taxas',
    contents:
      'Com programa de pontos, crédito garantido via investimento de até [R$ 70 mil] reais e muito cashback ao pagar sua fatura.',
  },
  {
    img: thirdCarouselImage,
    title: 'A maquininha que combina com sua conta gratuita',
    contents:
      'Antecipação de recebíveis, Pix QR Code sem taxas recebendo pelo Inter, cashback do aluguel e outros benefícios disponíveis.',
  },
  {
    img: fourthCarouselImage,
    title: 'Invista no futuro da sua empresa',
    contents:
      'A partir de R$1 com o Meu Porquinho ou encontre a melhor opção de investimento para o seu negócio.',
  },
]

export const contaMeiLabels = {
  CNPJ: 'Qual é o CNPJ da sua empresa?',
  FATURAMENTO: 'Qual o faturamento ou previsão mensal da empresa?',
  PAGE_NAME: 'Conta MEI',
  OPEN_MEI_ACCOUNT: 'Abrir conta Empresa ou MEI',
  NOT_OPEN_ACCOUNT: 'Agora não',
  CONTINUE: 'Continuar',
  UNDERSTOOD: 'Entendi',
  COMPANY_CNPJ: 'Qual é o CNPJ da sua empresa?',
  SENT_SUCCESS: 'Solicitação enviada com sucesso',
  SENT_FAILT: 'Não conseguimos enviar seu CNPJ',
}
